import { FC } from "react";
import { Link } from "react-router-dom";

const ToolbarLink: FC<{
  icon: string;
  active?: boolean;
  label?: string;
  badgeNumber?: number;
  badgeColor?: string;
  to: string;
}> = ({ label, badgeNumber, badgeColor = "blue", active, icon, to }) => {
  let linkClassName = "tab-link";
  if (active) {
    linkClassName += " active";
  }

  return (
    <Link to={to} className={linkClassName}>
      <i className={icon} style={{ fontSize: 24, marginTop: 3 }}>
        {badgeNumber && badgeColor ? <span className={`badge bg-${badgeColor}`}>{badgeNumber}</span> : null}
      </i>
      {label ? <span className="tabbar-label">{label}</span> : null}
    </Link>
  );
};

export default ToolbarLink;
